import { render, staticRenderFns } from "./LogoDisplay.vue?vue&type=template&id=ede8249e&scoped=true&"
import script from "./LogoDisplay.vue?vue&type=script&lang=js&"
export * from "./LogoDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede8249e",
  null
  
)

export default component.exports